import { render } from "./PlaceImageDetails.vue?vue&type=template&id=65284a61&scoped=true"
import script from "./PlaceImageDetails.vue?vue&type=script&lang=js"
export * from "./PlaceImageDetails.vue?vue&type=script&lang=js"

import "./PlaceImageDetails.vue?vue&type=style&index=0&id=65284a61&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65284a61"]])

export default __exports__